import styled from 'styled-components';
import { colours, slideToLeftTraysAnimation, spacing, zFilterMenu } from '../../../stylings';

export const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: flex-end;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: ${zFilterMenu};
`;

export const Menu = styled.menu`
  align-items: center;
  background-color: ${colours.WHITE};
  display: flex;
  flex-direction: column;
  margin: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: ${spacing.L} ${spacing.S};
  width: 310px;
  ${slideToLeftTraysAnimation}
`;
